import React from "react";
import ReactDOM from "react-dom/client";
import AuthGate from "./Auth";
import AmortIQ from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<AuthGate appName="AmortIQ">{(auth) => <AmortIQ auth={auth} />}</AuthGate>);
